;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { StockType } from '@qogita/canary-client/sellers'

const STOCK_TYPE_LABELS: Record<StockType, string> = {
  ON_FLOOR: 'On floor',
  PRE_ORDER: 'Pre-order',
  INCOMING: 'Incoming',
}

export function getStockTypeLabel(stockType: StockType): string {
  return STOCK_TYPE_LABELS[stockType]
}

export const DISPATCH_IN_0_WEEKS = '0'

export const DOWN_PAYMENT_PERCENTAGE_OPTIONS = [
  { value: '0.0', label: '0%' },
  { value: '0.3', label: '30%' },
] as const
